<div class="container">
    <div style="text-align: center;">
        <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" *ngIf="usuario==null"></span>
    </div>
    

    <div class="card shadow-lg border-0 rounded-lg mt-5" *ngIf="usuario!=null">
        <div class="card-header" style="color: teal;">
            <h3 class="text-center font-weight-light my-4">{{usuario.data().nombre}}</h3>
            <p>Id: {{usuario.id}}</p>
        </div>
        <div class="card-body">

            <div>
                <p>Editar datos de empresa:</p>
                <div>

                    <div class="form-group">
                        <label for="nombre">Nombre empresa:</label>
                        <input type="text" class="form-control" id="nombre" aria-describedby="emailHelp" placeholder="Ej: Servicios de petróleo SAS" [(ngModel)]="nombre">
                        <small id="emailHelp" class="form-text text-muted">ejemplo: Servicios de petróleo SAS</small>
                    </div>

                    <div class="form-group">
                        <label for="dominio">Dominio:</label>
                        <input type="text" class="form-control" id="dominio" aria-describedby="emailHelp" placeholder="@nombredelaempresa.com" [(ngModel)]="dominio">
                        <small id="emailHelp" class="form-text text-muted">ejemplo: @serviciosdepetroleo.com</small>
                    </div>

                    <div class="form-group">
                        <label for="responsable">Responsable:</label>
                        <input type="text" class="form-control" id="responsable" aria-describedby="emailHelp" placeholder="Juan Perez" [(ngModel)]="responsable">
                        <small id="emailHelp" class="form-text text-muted">ejemplo: Juan Perez</small>
                    </div>
  
                </div>
              </div>
            

            <ul class="list-group">
                <li class="list-group-item" *ngIf="procesodeEditarActivo">
                    <ngb-alert type="danger">
                        <strong>¿Guardar cambios?</strong>
                        <p><small>Confirme si quiere guardar los cambios</small></p>
                    </ngb-alert>
                    <div>
                        <button class="btn btn-primary" (click)="cancelaUpdate()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="update(usuario.id)" style="float: right; margin-right: 4px;">Guardar</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEditarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaUpdate()">Editar empresa</button>
                </li>

                <li class="list-group-item" *ngIf="procesodeEliminarActivo">
                    <ngb-alert type="danger">
                        <strong>¿Eliminar empresa?</strong>
                        <p><small>Los datos de la empresa se eliminarán</small></p>
                    </ngb-alert>
                    <div>
                        <p>
                            <ngb-alert [type]="tipodeAlerta" (close)="closeAlert()">{{ mensajeAlerta }} <span *ngIf="trabajando" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span></ngb-alert>
                        </p>
                        <button class="btn btn-primary" (click)="cancelarEliminar()" style="float: left; margin-left: 4px;">Cancelar</button>
                        <button class="btn btn-danger" (click)="eliminarEmpresa(usuario.id)" style="float: right; margin-right: 4px;">Eliminar</button>
                    </div>
                </li>
                <li class="list-group-item" *ngIf="!procesodeEliminarActivo">
                    <button class="btn btn-danger btn-block"  (click)="confirmaEliminar()">Eliminar empresa</button>
                </li>
              </ul>
           
        </div>
        <div class="card-footer text-center">
           <button class="btn btn-primary  btn-block" (click)="cerrar(null)">Cerrar</button>
        </div>
    </div>
</div>